<template>
    <div v-loading="pageLoading">
        <div class="comment">
            <div class="name ">{{ comment.createUserName }}</div>
            <div class="content">{{ comment.content }}</div>
            <div class="operation">
                <el-button type="text" @click="onReply(comment)">回复</el-button>
                <el-button class="btn-display" type="text" @click="onDisplay(comment)">{{ comment.status === 0 ? '开放' : '屏蔽' }}</el-button>
            </div>
        </div>
        <el-divider content-position="left">回复</el-divider>
        <div class="reply">
            <div class="reply-list" v-if="comment.replyList && comment.replyList.length > 0">
                <reply @onDisplay="onDisplay" @onReply="onReply" v-for="item in comment.replyList" :key="item.id" :reply="item" ></reply>
            </div>
            <div class="no-reply" v-else>暂无回复</div>
        </div>

        <div class="MT20">
            <el-button @click="goBack">返回</el-button>
        </div>

        <el-drawer
            title="回复"
            :visible.sync="visible"
            class="form-drawer"
            :append-to-body="true"
            :wrapper-closable="false"
            direction="rtl"
            size="400px"
        >
            <div class="drawer-content">
                <el-form ref="formData" :model="formData" :rules="rules" label-position="top">
                    <el-form-item prop="content">
                        <template slot="label">官方回复</template>
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 4}"
                            placeholder="请输入内容"
                            maxlength="200"
                            show-word-limit
                            v-model="formData.content">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="onCancel">取消</el-button>
                <el-button :loading="saveLoading" type="primary" @click="save()">提交</el-button>
            </div>
        </el-drawer>


    </div>
</template>
<script>
import Reply from './components/reply';
export default {
    props:{
        id:{
            type:[String,Number],
            default:""
        }
    },
    components:{Reply},
    data(){
        return{
            pageLoading: false,
            comment: {},
            visible: false,
            formData: {
                content: ''
            },
            saveLoading: false,
            rules: {
                content: [{ required: true, message: "请填写官方回复" }],
            },
            replyId: ''
        }
    },
    mounted(){
        if(this.id){
            this.getDetail();
        }
    },
    methods:{
        // 获取详情
        async getDetail() {
            this.pageLoading = true;
            const response = await this.$request({
                url: "/article/review/info",
                method: "POST",
                params: { id: this.id },
            });
            this.pageLoading = false;
            const {msg, state, result} = response.data;
            if (state != 1) return this.$message.error(msg);
            this.comment = result;
        },
        onDisplay(reply) {
            this.$confirm(`确认要${reply.status === 0 ? '开放' : '屏蔽'}该条回复`, '屏蔽/展示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(async () => {
                const response = await this.$request({
                    url: "/article/review/updateStatus",
                    method: "POST",
                    params: {id: reply.id, status: reply.status === 0 ? 1 : 0},
                });
                const {msg, state} = response.data;
                if (state != 1) return this.$message.error(msg);
                this.$message.success('回复操作成功');
                this.getDetail();
            })
        },
        onReply (reply) {
            this.visible = true;
            this.replyId = reply.id;
            this.$refs["formData"].clearValidate();
        },
        onCancel () {
            this.visible = false;
            this.formData.content = '';
        },
        save() {
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.saveLoading = true;
                    const response = await this.$request({
                        url: "/article/review/save",
                        method: "POST",
                        params: {id: this.replyId, content: this.formData.content},
                    });
                    const {msg, state} = response.data;
                    this.saveLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.$message.success('回复成功');
                    this.getDetail();
                    this.onCancel();
                }
            });
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.comment {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    transition: .3s;
    padding: 20px;
    .name {
        color: #333;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 14px;
    }
    .content {
        color: #666;
    }
}
.reply {
    padding: 20px;
    .no-reply {
        padding: 20px 0;
        color: #999;
        text-align: center;
    }
}
</style>